import { NBSP } from 'shared/constants/symbols';
import * as styles from './styles.css';
import { IconFunctionalInformationCircle16, Tooltip, useDeviceType } from '@cian/ui-kit';
import { clsx } from 'clsx';
import { ThreeUtpBlock } from 'shared/components/ThreeUtpBlock';
import { UTP } from './constants';
import { Wrapper } from 'shared/components/Wrapper';
import { Block } from 'shared/components/Block';
import { BigTitle } from 'shared/components/BigTitle';
import { SubTitle } from 'shared/components/SubTitle';
import { Description } from 'shared/components/Description';
import { Element } from 'react-scroll';
import { ENavigation } from 'shared/types/navigation';

export const SecondaryMarket: React.FC = () => {
  const device = useDeviceType();

  return (
    <div className={clsx(styles['container'], styles[device])}>
      <Wrapper>
        <Element name={ENavigation.SecondaryMarket}>
          <Block>
            <BigTitle text="Вторичный рынок" />
            <Description
              text={[
                {
                  value:
                    'Монетизация вторичного рынка недвижимости в Циан строится на размещении объявлений и дополнительных услугах по их продвижению.',
                },
              ]}
            />
            <SubTitle text="Как работает:" />
            <ul className={styles['list']}>
              <li className={styles['list-item']}>
                <Description
                  text={[
                    {
                      value: `Для агентов и агентств недвижимости действует модель${NBSP}СРТ (Cost per Time)${NBSP}—
оплата за размещение и продвижение объекта на фиксированный срок (30 дней)`,
                    },
                  ]}
                />
              </li>
              <li className={styles['list-item']}>
                <Description text={[{ value: 'Собственники жилья размещают объявления преимущественно бесплатно ' }]} />
                <Tooltip
                  theme="white"
                  title={'В МиМО и СПбиЛО размещение коммерческой недвижимости для собственников платное'}
                >
                  <span className={styles['tooltip']}>
                    <IconFunctionalInformationCircle16 color="icon-main-default" />
                  </span>
                </Tooltip>
              </li>
            </ul>
          </Block>
          <Element name={ENavigation.AdPlacement}>
            <div className={styles['utpblock']}>
              <SubTitle text="Форматы размещения на Циан" />
              <ThreeUtpBlock elements={UTP} />
            </div>
          </Element>
        </Element>
      </Wrapper>
    </div>
  );
};
